import DocumentInput from './document-input';

export default DocumentInput;
